import { Button } from "@sellar-io/components";
import { UseInfiniteQueryResult } from "@tanstack/react-query";
import { ForwardedRef, forwardRef } from "react";
import { SpinnerLegacy } from "..";

export const InfiniteLoadingButton = forwardRef(
  (
    { query }: { query: UseInfiniteQueryResult },
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    if (!query.hasNextPage) return null;
    if (query.isFetchingNextPage) return <SpinnerLegacy />;
    return (
      <div className={"flex h-[150px] items-center justify-center"}>
        <Button ref={ref} size={"small"} onClick={() => query.fetchNextPage()}>
          Load more
        </Button>
      </div>
    );
  },
);

InfiniteLoadingButton.displayName = "InfiniteLoadingButton";
